class Security {
  private publicKeyPem = process.env.NEXT_PUBLIC_CRYPTO_PUBLIC_KEY || "";

  private str2ab = (str: string) => {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
  };

  encrypt = async (data: string) => {
    try {
      const pemHeader = "-----BEGIN PUBLIC KEY-----";
      const pemFooter = "-----END PUBLIC KEY-----";

      const pemContents = this.publicKeyPem.substring(
        pemHeader.length,
        this.publicKeyPem.length - pemFooter.length - 1
      );
      const binaryDerString = window.atob(pemContents);
      const binaryDer = this.str2ab(binaryDerString);

      const encoder = new TextEncoder();
      const publicKey = await window.crypto.subtle.importKey(
        "spki",
        binaryDer,
        { name: "RSA-OAEP", hash: "SHA-256" },
        false,
        ["encrypt"]
      );

      const encryptedData = await window.crypto.subtle.encrypt(
        { name: "RSA-OAEP" },
        publicKey,
        encoder.encode(data)
      );

      return Buffer.from(encryptedData).toString("base64");
    } catch (e) {
      console.log(e);
      return null;
    }
  };
}

const security = new Security();
export default security;
